import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase-config';
import logoCaes from '../assets/images/logo.png'; 
import { FiMail, FiLock, FiAlertTriangle } from 'react-icons/fi';
import '../styles/AdminLogin.css';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@700&family=Poppins:wght@400;600&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/admin');
    } catch (err) { 
      setError('Error de autenticación. Verifique sus credenciales.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      {/* Panel Izquierdo - Branding */}
      <div className="login-branding-panel">
        <div className="branding-content">
            <img src={logoCaes} alt="Logo CAES" className="branding-logo" /> 
            <h1 className="branding-title">Editor de Contenidos</h1>
            <p className="branding-subtitle">Publicación de Noticias y Eventos</p>
        </div>
      </div>

      {/* Panel Derecho - Formulario */}
      <div className="login-form-panel">
        <div className="form-container">
            <div className="form-header">
                <h2>Bienvenido</h2>
                <p>Ingrese sus credenciales para continuar.</p>
            </div>

            <form onSubmit={handleLogin} className="login-form">
                <div className="input-wrapper">
                    <FiMail className="input-icon" />
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder="Correo Electrónico"
                    />
                </div>
                <div className="input-wrapper">
                    <FiLock className="input-icon" />
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        placeholder="Contraseña"
                    />
                </div>
                
                {error && (
                  <div className="error-box">
                    <FiAlertTriangle />
                    <span>{error}</span>
                  </div>
                )}
                
                <button type="submit" className="btn-login" disabled={isLoading}>
                    {isLoading ? 'Verificando...' : 'Iniciar Sesión'}
                </button>
            </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;